var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.active)?_c('WorkRights',{attrs:{"value":_vm.profile.workRights,"autofocus":""}}):_vm._e(),_c('v-btn',{attrs:{"block":"","color":_vm.themes.candidate.light.primaryActionButton,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('input')}}},[_vm._v("\n    Save\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }